// extracted by mini-css-extract-plugin
export default {"material_container":"style_material_container__NRXNw","type_grid":"style_type_grid__P6blQ"};